<template>
  <div class="clinic-integration-tab" v-loader.opacity.tab="loading">
    <div class="clinic-integration-list" id="integration-list" v-if="!isEdit">
      <BaseTable class="no-border" v-if="tableIntegrations" :tabledata="tableIntegrations" @item-opened="toDetails">
        <template v-slot:column_status="{item}">
          <span class="badge" :class="item.enabled ? 'bg-success' : 'bg-secondary'">
            {{ item.enabled ? $t('integration.statusEnabled') : $t('integration.statusDisabled') }}
          </span>
        </template>
      </BaseTable>
    </div>

    <div class="clinic-edit-box" v-else>
      <ClinicIntegrationEdit
        :clinic_id="clinic_id"
        :integration="selectedIntegration"
        @cancel-edit="cancelEdit"
        @saved="onSaved"/>
    </div>

    <div class="action-bar" v-if="!isEdit">
      <button class="btn btn-success" type="button" name="button" data-test="btnNewIntegration" @click="newIntegration">
        <span>{{ $t('integration.new') }}</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.clinic-integration-list {
  padding:                         0 10px 10px 10px;
  flex:                            1;
}

@media (min-width: 992px) {
  .clinic-integration-tab {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
  }

  .clinic-integration-list {
    display:                       flex;
    flex-direction:                column;
    min-height:                    0;
    overflow:                      hidden;
  }

  .clinic-edit-box {
    display:                       flex;
    flex-direction:                column;
    flex:                          1;
    min-height:                    0;
  }
}

@media (max-width: 991px) {
  .clinic-integration-list {
    height:                        calc(100dvh - 258px);
    max-height:                    calc(100dvh - 258px);
    padding:                       0;
    overflow-y:                    auto;
    overscroll-behavior:           contain;
    scrollbar-width:               none;

    &::-webkit-scrollbar {
      display:                     none;
    }
  }
}
</style>

<script src="./ClinicIntegrationsTab.js"></script>
